import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useMatchUrl = createRouterSelector((state) => state.match.url);

export const RedirectToPlaybookEditPage = (): React.JSX.Element => {
	const matchUrl = useMatchUrl();
	const editUrl = matchUrl.replace('/settings/playbooks/', '/settings/playbooks/edit/');

	// persistSearchParams forwards the current query string (step, fromPlaybookId, aiResultId, fromTab).
	return <ScreenRedirect to={editUrl} persistSearchParams />;
};
